export const getOnlyNumbers = (value): string => value.replace(/[^0-9]/g, '')
